import { EstimatedPaymentData } from '../../api/types';
import { NormalizedPaymentAssets } from '../reducer';

export const normalizeEstimatedAmountByTokenId = (
  tokens: NormalizedPaymentAssets['tokens'],
  amountToPay: EstimatedPaymentData['amountToPay'],
) => {
  return tokens.allIds.reduce<Record<string, number>>((acc, _tokenId) => {
    const token = tokens.byId[_tokenId];
    const tokenValue = amountToPay[token.symbol.toLowerCase()];

    if (tokenValue !== undefined) {
      acc[_tokenId] = tokenValue;
    }

    return acc;
  }, {});
};
